import React, { useCallback, useState } from "react"
import PropTypes from "prop-types"

import { Formats } from "./formats"
import { useTopicUpdater } from "./updater"

const Topic = props => {
  Topic.propTypes = {
    path: PropTypes.string.isRequired,
    format: PropTypes.string.isRequired,
    type: PropTypes.string
  }

  const [data, setData] = useState(props)
  const Format = Formats[data.format]
  const handleUpdate = useCallback(nextData => {
    setData(nextData)
  }, [])

  useTopicUpdater({ path: data.path, status: data.status, onUpdate: handleUpdate })

  if (Format == undefined) {
    throw `Format Error. Couldn't find the following format: ${props.type
    }. Following types are accepted:\n ${Object.keys(Formats).join("\n ")}`
  }

  return <Format {...data} />
}

export { Topic }
